import type { FetchFunction } from '#layers/base/public';
import type { MonospaceRole, MonospaceUserRole } from '#layers/data-model/public';
import { withItemType } from '@rstore/vue';
import { isPromiseResultRejected, omit } from '#layers/base/public';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';
import { compositeKey } from '~/rstore/utils/composite-key';

export function createWorkspaceRole(workspaceFetch: FetchFunction) {
	return withItemType<MonospaceRole>().defineCollection({
		name: 'MonospaceRole',
		scopeId: MONOSPACE_SCOPE_ID,
		meta: {
			defaultFields: ['id', 'name'],
			fetchOnCreate: true,
			endpoint: 'roles',
			transformBeforeCreate: (role: MonospaceRole) => omit(role, ['id']),
		},
		hooks: {
			deleteMany: async ({ keys }) => {
				const results = await Promise.allSettled(keys.map((key) =>
					workspaceFetch(`roles/${key}`, {
						method: 'DELETE',
					}),
				));

				if (results.some((result) => isPromiseResultRejected(result))) {
					throw new Error('Failed to delete some roles');
				}
			},
		},
	});
}

export const UserRole = withItemType<MonospaceUserRole>().defineCollection({
	name: 'MonospaceUserRole',
	scopeId: MONOSPACE_SCOPE_ID,
	getKey: (item) => compositeKey(item.userId, item.roleId),
	meta: {
		defaultFields: ['userId', 'roleId'],
		endpoint: 'system/user-role',
	},
});
